import { render, staticRenderFns } from "./PrintDailyProtocol.vue?vue&type=template&id=10dd5e61"
import script from "./PrintDailyProtocol.vue?vue&type=script&lang=js"
export * from "./PrintDailyProtocol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports